<!-- 詢問是否開啟聲音 -->
<template>
    <div class="sound-mask"
    :class="{'show': show }"
    v-show="isDisplay">
        <div class="sound-container">
            <p>是否開啟背景音效</p>
            <div class="btn-wrapper">
                <img src="@/assets/images/sound/btn_sound_on@2x.png" alt="" class="sound-btn on"
                @click="$parent.playBgMusic(true);gaEvent(gaCategory, 'soundon_intro');">
                <div class="slash"></div>
                <img src="@/assets/images/sound/btn_sound_off@2x.png" alt="" class="sound-btn on"
                @click="$parent.playBgMusic(false);gaEvent(gaCategory, 'soundoff_intro');">
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
            required: true,
        },
    },
    data() {
        return {
            gaCategory: 'sound_btn',
            isDisplay: false,
        };
    },
    watch: {
        show(val) {
            if (!val) {
                window.setTimeout(() => {
                    this.isDisplay = val;
                }, 800);
            } else {
                this.isDisplay = val;
            }
        },
    },
    mixins: [mixinMethod],
};
</script>

<style lang="sass" scoped>

.sound-mask
    background-image: url('../assets/images/loading/bg_loading@2x.png')
    background-color: #000
    background-repeat: no-repeat
    background-position: 50% 100%
    background-size: cover
    width: 100vw
    height: 100vh
    top: 0
    left: 0
    position: fixed
    opacity: 0
    transition: .8s ease-in-out
    z-index: 10
    &:after
        background-color: rgba(#000, .6)
        content: ''
        display: block
        height: 100vh
        animation-name: blackRun
        animation-duration: 2s
        animation-iteration-count: infinite
        animation-timing-function: ease-in
        animation-delay: 500ms
    &.show
        opacity: 1

.sound-container
    $s: 50vh
    position: absolute
    text-align: center
    top: 14vh
    left: calc(50% - 25vh)
    width: $s
    height: $s
    .sound-btn
        $s: 11.5vh
        cursor: pointer
        display: inline-block
        width: $s
    .slash
        $s: 8vh
        background-color: #fff
        display: inline-block
        width: $s
        height: 1px
        transform: rotate(120deg)
        margin: 0 1em
    p
        color: #fff
        font-size: 1.2em
        width: 1em
        margin: 0 auto 3em

@media (min-width: 768px)
    .sound-mask
        background-image: url('../assets/images/loading/bg_loading@3x.png')
    .sound-container
        top: 18vh

@media (min-width: 1200px)
    .sound-container
        top: 20vh
</style>
